// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelXSmall } from 'baseui/typography';

// ANCHOR Models
import { useCourseDataId } from '@lyon/scoped-models/CourseData';
import { useCourseModulePaymentPanelDataModuleItems } from '@lyon/scoped-models/course-payment/CourseModulePaymentPanelData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonEmptyState } from '@lyon/components/empty/LyonEmptyState';
import {
  ModulesInteractableTreePrefix,
} from '@lyon/components/utils/ModulesInteractableTree/ModulesInteractableTreeSubItem/ModulesInteractableTreePrefix';
import {
  ModulesInteractableTreeLabel,
} from '@lyon/components/utils/ModulesInteractableTree/ModulesInteractableTreeSubItem/ModulesInteractableTreeLabel';

// ANCHOR Constants
import { LABEL, EMPTY } from './constants';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonCourseOutlinePanelBody = constant(() => {
  const moduleItems = useCourseModulePaymentPanelDataModuleItems();
  const courseId = useCourseDataId();

  if (!courseId) {
    return <Loader />;
  }

  if (moduleItems.length === 0) {
    return (
      <LyonEmptyState
        label={EMPTY}
        imgAlt={EMPTY}
      />
    );
  }

  return (
    <>
      <LabelXSmall marginBottom="16px">
        {LABEL}
      </LabelXSmall>
      {
        moduleItems.map((item) => (
          <Block overrides={BLOCK} key={item.id}>
            <ModulesInteractableTreePrefix
              itemType={item.itemType}
            />
            <ModulesInteractableTreeLabel
              courseId={courseId}
              moduleItemId={item.id}
              title={item.title}
            />
          </Block>
        ))
      }
    </>
  );
});
